import React, { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Divider, Skeleton, Avatar, Space, Row, Col, Button } from "antd";
import { UserOutlined, SettingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";
import DiscountForm from "./form";
function DiscountsTableDetails({ id, onDataUpdate, onCloseDrawer }) {
  const GETDISCOUNT = gql`
    query ($id: ID!) {
      getDiscount(id: $id) {
        createdAt
        updatedAt
        percent
        title
        code
        maxCount
        expiresAt
        useCount
        productIds
        userIds
      }
    }
  `;
  const [initialData, setInitialData] = useState({});

  const [formData, setFromData] = useState(null);

  const [getDiscountData, discountData] = useLazyQuery(GETDISCOUNT, {
    fetchPolicy: "no-cache",
    onCompleted({ getDiscount }) {
      console.log(getDiscount?.productIds);
      
      const discountData = {
        expiresAt: moment(getDiscount?.expiresAt),
        percent : getDiscount?.percent,
        title : getDiscount?.title,
        code: getDiscount?.code,
        maxCount: getDiscount?. maxCount,
        useCount: getDiscount?.useCount,
        productIds: getDiscount?.productIds.length === 0 ? ["all"] : getDiscount?.productIds,
        userIds : getDiscount?.userIds.length === 0 ? ["all"] : getDiscount?.userIds,
      };
      setFromData(discountData);
      const { createdAt, updatedAt} =
        getDiscount;
      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
      });
    },
  });
  useEffect(() => {
    if (id) {
      getDiscountData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  // const TransactionDataUpdated = () => {
  //   getTranactionlData({
  //     variables: {
  //       id,
  //     },
  //   });
  // };

  const { createdAt, updatedAt } = initialData;

  if (discountData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>

      <Divider style={{ fontWeight: 700 }} orientation="right">
        اطلاعات تخفیف
      </Divider>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ درخواست: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
        <Space align="">
            <p>تاریخ اخرین تغییر: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>

      <DiscountForm
        formData={formData}
        onDoUpdateData={onDataUpdate}
        onDoCloseDrawer={onCloseDrawer}
        id={id}
      />
    </>
  );
}

export default DiscountsTableDetails;
